import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import ErrorPageTemplate from './ErrorPageTemplate';

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (error) {
      const msg =
        error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : 'Unknown error occurred';
      enqueueSnackbar(`Route error: ${msg}`, { variant: 'error' });
    }
  }, [error, enqueueSnackbar]);

  return (
    <ErrorPageTemplate
      errorText={'Oops! Something went wrong.'}
      description={'Please refresh the page or contact support.'}
    />
  );
};
